/*
* Auth: 朱广龙
*/
import { useEffect, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import usePagination from './_hook/usePagination';

/**
 * （待废弃）用于快速完成列表页面开发 使用场景: 配合Table进行列表渲染(分页场景或者不分页场景均可)
 * @param { Function } getList 接口请求函数
 * @param { Object } searchParams 分页查询需要的参数
 * @param { Function } cb  接口回调以后可能需要做一些特殊处理
 * @return { Object } 接口返回的数据
 * @example
 *  const getList = (args) => {
 *    const p = new Promise((resolve) => {
 *      setTimeout(() => {
 *        resolve([])
 *    })
 * })
 * }
 * 
 * const [{ loading, pagination }, resetResult] = useTable(getList, {}, () => {
 * })
 * 
 * return (
 *  <Table
 *    dataSource={tableData}
 *     rowKey='id'
 *     loading={loading}
 *     expandable={{
 *       expandedRowRender,
 *       expandedRowKeys,
 *       onExpandedRowsChange,
 *     }}
 *     columns={columns as any}
 *     pagination={pagination}/>
 * )
 */
function useTable(getList, searchParams = {}, cb) {
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const pagination = usePagination(total);
  const { current, pageSize } = pagination;
  const [resetResult, setrestResult] = useState({});

  if (typeof getList !== 'function') {
    throw new Error(`useTable expected parameter is a function, got ${typeof fn}`)
  }

  // 调接口
  const getTables = async (current ,pageSize, searchParams) => {
    setLoading(true);
    const result = await getList(current, pageSize, searchParams);
    if (!result) return;

    const { totalNum = 0, ...restResult } = result || {};
    // 批量更新
    unstable_batchedUpdates(() => {
      setTotal(totalNum);
      setLoading(false);
      // 考虑到可能存在权限以及部分页面不需要分页
      setrestResult(restResult)

      // 用于告诉外界当前接口是否执行完毕
      // cb?.();
      // 存在移动端兼容性问题
      if (typeof cb ==='function') {
        cb();
      }
    });
  };

  // 这个地方统一调接口数据
  useEffect(() => {
    // 增加visible参数用于解决在modal页面中弹框未打开提前发送请求
    searchParams.visible  = 
    typeof searchParams.visible === 'function' 
    ? searchParams.visible() 
    : searchParams.visible;
    const { visible,  ...restsearchParams } = searchParams;

    if (visible === undefined || visible) {
      getTables(current, pageSize, restsearchParams);
    };

  }, [current, pageSize, searchParams]);

  return [{loading, pagination}, resetResult];
};

export default useTable;
